module.exports = __webpack_public_path__ + "static/media/start_student.7301322e.png";